// Lazy-load the model-viewer web component (public/model-viewer.js, ~1MB
// uncompressed / ~271KB gzipped). It used to be an eager <script type="module">
// in index.html, so EVERY page — including turntable products that render only
// image frames and never use <model-viewer> — paid to download+parse it on the
// critical path. Now it loads on demand, only when a 3D <model-viewer> is about
// to mount. Idempotent: the script is injected at most once and the promise is
// shared across callers.
let _promise = null;

export const isModelViewerDefined = () =>
  typeof window !== "undefined" &&
  !!window.customElements &&
  !!window.customElements.get("model-viewer");

export const loadModelViewer = () => {
  if (typeof window === "undefined") return Promise.resolve();
  if (isModelViewerDefined()) return Promise.resolve();
  if (_promise) return _promise;
  _promise = new Promise((resolve) => {
    const src = `${process.env.PUBLIC_URL || ""}/model-viewer.js`;
    // If a matching script tag is already in the DOM (e.g. a legacy index.html
    // still ships it), wait on customElements rather than injecting a second one.
    const existing = document.querySelector(`script[src="${src}"]`);
    const done = () =>
      (window.customElements
        ? window.customElements.whenDefined("model-viewer")
        : Promise.resolve()
      ).then(resolve, resolve);
    if (existing) {
      done();
      return;
    }
    const s = document.createElement("script");
    s.type = "module";
    s.src = src;
    s.onload = done;
    s.onerror = resolve; // never block the app if the CDN/script fails
    document.head.appendChild(s);
  });
  return _promise;
};
